import { Component,Input, Injectable, OnInit, OnDestroy, AfterViewInit ,ElementRef, ViewChild, HostListener} from '@angular/core';

import { fromEvent } from 'rxjs';
import { Subscription } from 'rxjs';
import {ProductModel, IDisplayableElements, IConfigObj, UserInfoService, QuickAddBasketV1Service, QuickAddCheckboxService, BadgeModel, EnviormentConfig } from 'abs-ngx-library/src/lib/core';
import {CommonService,  ProductUtilService, AemService, IntersectionObserverService } from 'abs-ngx-library/src/lib/core';

declare let $: any;

@Component({
selector: 'product-item-al-v2',
templateUrl: './product-item-al-v2.component.html',
providers: [QuickAddCheckboxService]
})

@Injectable()
export class ProductItemALV2Component implements OnInit, OnDestroy, AfterViewInit {

private _product: ProductModel;
private imagePath: string;
private envConfig = EnviormentConfig;

@Input()
public pathwaysWidget: any;
public reservedTimeIntent: string = '';

@Input() public configObj: IConfigObj;
@Input() isCalledByRightDrawerOrOneTimeAddFlow: boolean = false;
@Input() public offers;

@Input() isAnyProductHasAddlInfo: boolean;

@Input('isRestricted')
public unAttendDeliveryFlag: boolean;

public productCouponVisible: boolean;

public productDetailPath :string ='';
public sm = '575px';
public md = '768px';
public bgImgOpaque: string = 'product-image-opaque-full';
public itemAvailable: boolean = true;
public isArEnable: boolean = false;
public isItemEligibleToAdd: boolean = true;
public isSlotWithInDelihours: boolean = true;
// README: Variable used for displaying the correct product price based on promo
public validPrice: number;
private subscription: Subscription = new Subscription();
public displayableElements: IDisplayableElements;
public sellerLandingPath: string = '';
public ratingStars: number[];
public productOffers = {};
public subscriptionSNS: Subscription;
public isProductSubscribed: boolean = false;
public pcTags = []; 
public isCustomizableProduct = false;
public enableOOSReDesign: boolean;
public hideBuyAgainTag : boolean = false;
public isCheckboxChecked: boolean = false;
public isDigitalDeliProductStoreNotEligible: boolean = false;
@ViewChild('checkboxInput') checkboxInput: ElementRef<HTMLInputElement>;
badgeToDisplay: BadgeModel;
public digitalDisplayTimeLabel:string = '';
public isEligibleCustomCakeProduct: boolean = false;
public constructor(
  public  commonService: CommonService,
  private productUtilService: ProductUtilService,
  private aemService: AemService,
  private elementRef: ElementRef,
  private _userInfoService: UserInfoService,
  private intersectionObserverService: IntersectionObserverService,
  private _elementRef: ElementRef,
  private _quickAddBasketService: QuickAddBasketV1Service,
  private _quickAddCheckboxService: QuickAddCheckboxService
) {
}
@Input()
public calledBy: string;

@Input('data')
set product(product: ProductModel) {
  this.addElipsis(product); 
  this.commonService.checkStrikeThrough(product);

  this._product = product;
  this.ratingStars = this.getStarRatings(product?.productReview?.avgRating);
}

get product(): ProductModel {
  return this._product;
}

public ngOnInit() {
  // Get the image path from the environment
  const currentEnvironment = this.commonService.getCurrentEnviorment();
  const baseImagePath = this.envConfig[currentEnvironment]?.baseImageUrl ? this.envConfig[currentEnvironment]?.baseImageUrl : '//images.albertsons-media.com/is/image/ABS';
  this.imagePath = baseImagePath + '/' + '${product.id}?$grid-product-card-${viewport}$&defaultImage=Not_Available';
  this.performInitialChecks();
  this.setDisplayableElements();
  this.getLatestArSubData();
  this.setSellerLandingPath();
  this.setTagDisplayableElements();
  this.enableOOSReDesign = this.calledBy== 'buy-it-again' || this.calledBy === 'buyItAgain' || this.calledBy === 'buy-it-again-qsc' || this.calledBy === 'buyItAgainQsc';
  this.hideBuyAgainTag = this.calledBy== 'buy-it-again' || this.calledBy === 'buyItAgain' || this.calledBy === 'buy-it-again-qsc' || this.calledBy === 'buyItAgainQsc';
}

public performInitialChecks() {
  this.isDigitalDeliProductStoreNotEligible = this.commonService.isDigitalDeliProductStoreNotEligible(this.product);
  this.isEligibleCustomCakeProduct = this.commonService.isEligibleCustomCakeProduct(this.product);
  // Check for arFlag else listen to arFlagLoaded
  if(window['AB']['arFlagLoaded']){
      this.isArEnable = window['AB']['arFlag']['display'];
      this.isCustomizableProduct = this.commonService.isProductEligibleForCustomization(window['AB'].storeFlagsData, this.product);

  } else {
      this.subscription.add(
          fromEvent(document, 'arFlagLoaded').subscribe(event => {
              this.isArEnable = event && event['detail'] && event['detail']['arFlag'] ? event['detail']['arFlag']['display'] : false;
              // set isCustomizableProduct flag based on store eligibility and isMtoProduct/isCustomizable
              this.isCustomizableProduct = this.commonService.isProductEligibleForCustomization(window['AB'].storeFlagsData, this.product);

          })
      );
  }
  //Set productOffers for snsOneTime
  this.productOffers = this.commonService.getOffersByUpc(this.product,this.offers);
  //Checking Item is available based on status & some other 
  this.itemAvailable = this.commonService.isItemAvailable_v3(this.product, this.configObj?.programType, true, this.isDigitalDeliProductStoreNotEligible, this.isEligibleCustomCakeProduct);
  this.configObj = this.product.isMarketplaceItem == 'Y' ? { ...this.configObj, programType: 'mkp' } : this.configObj;
  if (this._product?.name && this.commonService.isSeoEnabled()) {
    this.productDetailPath = this.commonService.buildSeoPdpUrl(this._product['fullName'] || this._product.name, this._product.id);
  } else {
    this.productDetailPath = this.commonService.getProductDetailPath(this.configObj?.programType);
    if (this.productDetailPath) {
      this.productDetailPath = this.productDetailPath.replace('(bpn)',  this._product.id);
    }
  }
  this.validPrice = this.commonService.getValidProductPrice(this._product);

  //Checking if the product is MTO and we are in edit order flow
  if(this.commonService.checkPendingOrder() && (this.product?.isMtoProduct || this.product?.isPreOrderItem)){
    const abSlotEditOrder = localStorage.getItem('abSlotEditOrder');
    this.reservedTimeIntent = JSON.parse(abSlotEditOrder)?.serviceType ?? '';
    const {hyphinFormat} = this.productUtilService.formatTimeSlots('abSlotEditOrder');
    this.digitalDisplayTimeLabel = hyphinFormat ?? '';
    if (abSlotEditOrder) {
      this.isItemEligibleToAdd = !this.commonService.preparationTimeExceedsPrebook(this.product, 'abSlotEditOrder');
      this.isSlotWithInDelihours =  (this.isEligibleCustomCakeProduct) || this.productUtilService.isSlotValidAtCurrentTime(window['AB']?.['storeFlagsData']?.['flags']?.['departmentsDetail'], 'Deli','abSlotEditOrder');
    } else {
      this.isItemEligibleToAdd = false;
    }
  }

  if (this.product['averageWeight'] < 1 && this.product['averageWeight'] > 0 && this.product.displayUnitQuantityText !== 'ea') {
    this.product['averageWeightStr'] = this.product['averageWeight'][0].substring(1, 4);
  }

  //added coupons check
  this.productCouponVisible = this.itemAvailable && this.calledBy !== 'c-products-by-upc-drawer' && this.calledBy !== 's-bogo';

}

public getLatestArSubData(){
   // subscribing to the behavioral subject - arSubscriptions
   this.subscriptionSNS = this.commonService.arSubscriptions.subscribe((data) => {
    if(!!data && !this.commonService.isEmpty(data) ) {
      this.isProductSubscribed = data.subscribedItems[this.product.id] && data.subscribedItems[this.product.id]?.isActiveSubscription;
    }
    this.setBadgeToDisplay();
    this.commonService.checkStrikeThrough(this.product);
  });
}

public setTagDisplayableElements() {
  this.pcTags = this.productUtilService.productTagElements(this.product, this.displayableElements);
}

// To get elements as per IDisplayableElements interface
private setDisplayableElements(){
  const programType = this.configObj?.programType ? this.configObj?.programType : 'abs';
  this.displayableElements = this.productUtilService.getProductDisplayableElementsByProgramType(programType);
}
//Adding ellipses to product name if it is greater than 60 characters
private addElipsis(product: ProductModel) {
  if (product?.name && product?.name.trim().length > 60) {
    product['fullName'] = product['name'];
    product['name'] = product?.name.slice(0, 30) + '...' + product?.name.slice(-20);
  }
}

private setSellerLandingPath(){
  if(this.configObj?.programType && (this.configObj.programType === 'mkp' || this.configObj.programType === 'mkp-carousel' || (this.product?.isMarketplaceItem && this.product.isMarketplaceItem === 'Y'))) {
    this.sellerLandingPath = this.commonService.getSellerLandingPath(this.product.sellerId);
  }
}

public ngAfterViewInit(): void {
  if (this.product &&
    this.product['adId'] || this.product.eventTracking) {
    this.intersectionObserverService.createObserver(this._elementRef.nativeElement, this.product);
  }
  if (this.calledBy === 'buyItAgainQsc') {
    this.performQscFlowSetup();
  }
  // Trigger lazy loading for all pagination types.
  if (window['AB']['LAZYLOAD'] && typeof window['AB']['LAZYLOAD'].init == 'function') {
      window['AB']['LAZYLOAD'].init();
  }
}

public getImageUrl(id: string, viewport: string): string {
  const modifiedImagePath = this.imagePath;
  return modifiedImagePath ? modifiedImagePath.replace('${product.id}', id).replace('${viewport}', viewport) : '';
}


/**
* Method to check Schedule and Save 
*/
public showArSubscription = (): boolean =>
    this.isArEnable && !!this.product && this.product.isArProduct && this.commonService.isActiveProduct(this.product);

  //For citrusAdTracker refering to V1 on Click of image 
  public sendAdIdClickEvent() {
    this.commonService.sendSponsoredProductClickEvent(this.product,'productCardGridOrCrossSell','viewProductDetails');
  }

  /**
   * Method to handle clicking on product refering to V1 calling on Image and Product Name
  **/
  public onProductClicked() {
    // make ad relevance call for all products
    this.commonService.recordRelevanceImpression(this.product, 'productCardGridOrCrossSell', 'viewProductDetails');
  }

  //Checking isLBProduct() while diaplay price
  public isLBProduct(): boolean {
    return this.product?.displayType === '3' && (this.product?.sellByWeight === 'W' || this.product?.sellByWeight === 'P');
  }

// Sets the pfmDetail in localStorage to be used in analytics tracking on pdp navigation
  public setPfmDetailProduct(isSpotlight?:boolean) {
    if (window['AB']?.DATALAYER) {
      const analyticsProductInfo = {
        isSpotlight : isSpotlight,
        isPastPurchased: this._product?.pastPurchased,
        isSponsored: this._product?.featured,
        pathwaysWidget: this.pathwaysWidget
      };
      window['AB'].DATALAYER.setPfmDetailProductItemToPDP(this.elementRef.nativeElement, this._product, analyticsProductInfo);
    }
  }

  public getStarRatings = (rating: string): number[] => {
    if (rating) {
      const averageRating: number = Number(rating);
      const fullStarsCount = Math.floor(averageRating);
      const partialStarIndex = fullStarsCount > 0 ? fullStarsCount : 0;
      const partialStar = (averageRating - fullStarsCount) * 100;
      const arrFinalStarPercentages: number[] = [];

      let finalPartialStarPercentage: number = 0;
      switch (true) {
        case (partialStar > 0 && partialStar <= 25):
          finalPartialStarPercentage = 0;
          break;
        case (partialStar > 25 && partialStar <= 75):
          finalPartialStarPercentage = 50;
          break;
        case (partialStar > 75 && partialStar <= 100):
          finalPartialStarPercentage = 100;
          break;
        default:
          break;
      }

      for (let i = 0; i < 5; i++) {
        if (i < fullStarsCount) {
          arrFinalStarPercentages[i] = 100;
        } else if (i == partialStarIndex) {
          arrFinalStarPercentages[i] = finalPartialStarPercentage;
        } else {
          arrFinalStarPercentages[i] = 0;
        }
      }
      return arrFinalStarPercentages;     
    }

    return [0, 0, 0, 0, 0];
  }
  public showPCReview(product){
    return (this.calledBy !== 'buy-it-again' && this.calledBy !== 'buyItAgain'
        && product
        && product.productReview
        && product.productReview.isReviewDisplayEligible === 'true'
        && product.productReview.avgRating
        && product.productReview.avgRating != ''
        && product.productReview.avgRating != '0.0'
        && product.productReview.avgRating != '0'
        && product.productReview.avgRating != null
        && product.productReview.reviewCount > 0
      );
  }

  public viewSimilarClick() {
      if (this.calledBy && (this.calledBy == 'buy-it-again' || this.calledBy == 'buyItAgain')) {
          this.commonService.showBiaLPCrossSell(this.product.id);
          if (window['AB'] && window['AB'].DATALAYER) {
              window['AB'].DATALAYER.setViewSimilarItemsClick(this._product);
          }
      }
      else {
          let redirectUrl = "/bin/safeway/product/similar?aisleId={product.aisleId}";
          redirectUrl = redirectUrl.replace('{product.aisleId}', this.product.aisleId);
          window.location.href = redirectUrl;
      }
    }
    public analyticsSimilarItemsCTA() {
      if (window['AB']?.DATALAYER) {
        window['AB'].DATALAYER.analyticsCTATracking(`cta:${window['AB'].DATALAYER.pathSections?.join(':')}|link|view-similar-items`);
      }
    }

  private performQscFlowSetup() {
    this.isCheckboxChecked = this._quickAddBasketService.isProductSelected(this.product.id);
    this._quickAddCheckboxService.setCheckboxState(this.isCheckboxChecked);
    this.setCheckboxInputState(this.isCheckboxChecked);

    if (this._quickAddCheckboxService !== undefined) {
      this.subscription.add(this._quickAddCheckboxService.isChecked$.subscribe((isChecked: boolean) => {

        if (isChecked === false) {
          this.checkboxInput.nativeElement.focus();
        }
       
        if (this.isCheckboxChecked === isChecked) {
          return;
        }
        this.isCheckboxChecked = isChecked;
        this.setCheckboxInputState(this.isCheckboxChecked);
      }))
    }
  }

  private setCheckboxInputState(state: boolean) {
    if (this.checkboxInput !== undefined) {
      this.checkboxInput.nativeElement.checked = state;
    }
    
  }

  public onCheckboxClick(event: Event) {
    const input = event.target as HTMLInputElement;
    this.isCheckboxChecked = input.checked;
    this._quickAddBasketService.setQuickAddBasketSelectedProperty(this.product.id, this.isCheckboxChecked);
    this._quickAddCheckboxService.setCheckboxState(this.isCheckboxChecked);
  }

  public setBadgeToDisplay() {
      this.badgeToDisplay = this.productUtilService.getBadgeToDisplay(this.isProductSubscribed, this.product);
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
    this.subscriptionSNS.unsubscribe();
  }
  
}
